import useTranslation from "../../../hooks/useTranslation";
import styles from "./VMVDescription.module.scss";


function VMVDescription() {
  const { t } = useTranslation();

  return (
    <article className={styles.vmvDescription}>
      <p>
        {t("components.vmvDescription.desc1")}
      </p>
      {/* <br /> */}
      <p>
        {t("components.vmvDescription.desc2")}

        {/* <strong>
          {t("components.vmvDescription.article")} {process.env.REACT_APP_DATE_EVENT_LITERAL} {t("components.vmvDescription.p1")}
        </strong>
        <br></br>
        {t("components.vmvDescription.p2")}
      </p>
      <p>
        {t('components.vmvDescription.p3')}
      </p>
      <strong>
        {t("components.vmvDescription.p4")}
        <br></br>
        {t("components.vmvDescription.p5")}
      </strong> */}
      </p>
    </article>
  );
}

export default VMVDescription;
